import { render, staticRenderFns } from "./UserReferrals.vue?vue&type=template&id=203b39d2&scoped=true&"
import script from "./UserReferrals.vue?vue&type=script&lang=js&"
export * from "./UserReferrals.vue?vue&type=script&lang=js&"
import style0 from "./UserReferrals.vue?vue&type=style&index=0&id=203b39d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203b39d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('203b39d2')) {
      api.createRecord('203b39d2', component.options)
    } else {
      api.reload('203b39d2', component.options)
    }
    module.hot.accept("./UserReferrals.vue?vue&type=template&id=203b39d2&scoped=true&", function () {
      api.rerender('203b39d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/UserReferrals.vue"
export default component.exports